/**
 * 補足対応（完了済みの依頼に続けて出す追加依頼）の共有ルール。どの依頼から起票できるか・元依頼から何を
 * 引き継ぐか・両側に張る対のリンクの形を 1 箇所に置き、フォーム（ボタンの出し分けと事前入力）と API
 * （起票時の門番とリンク付与）が同じ規則を使う。
 *
 * 補足対応は通常の新規依頼と同じ起票経路を通る（採番・SLA・当番割当・Slack の新スレッド）。ここが持つのは
 * 元依頼との関係だけ。種別は対応内容が変わりやすいので引き継がず、起票者が選び直す。
 * @graph-stack ops-core
 * @graph-domain Operations
 * @graph-business 補足対応の共有ルール。完了済みのダッシュボード起票の依頼からだけ起票でき、サービス・対象ユーザー・背景・WFID・CS チケット URL を引き継ぐ（種別と対応依頼は引き継がず選び直す）。補足対応側に「補足対応元」、元依頼側に「補足対応」の対リンクを張る
 * @graph-connects opsNoIsFirestoreNative [calls] ダッシュボード起票（Firestore 発番）の依頼か判定
 */
import { opsNoIsFirestoreNative } from './id.js';
/**
 * その依頼から補足対応を起票できるか。完了済み（closed）のダッシュボード起票の依頼に限る（シート由来の
 * legacy 依頼は書き込めず、元依頼側へリンクを張れないため）。
 * @graph-connects opsNoIsFirestoreNative [calls] Firestore 発番か判定
 */
export function canCreateOpsFollowUp(request) {
    return request.state === 'closed' && opsNoIsFirestoreNative(request.id);
}
/**
 * 元依頼から補足対応のフォームへ引き継ぐ値を取り出す。対象ユーザーが空の元依頼は N/A（null）として引き継ぐ
 * （保存時に N/A も [] に畳まれるため、空配列のまま渡すとフォームが「未入力」エラーになる）。
 * @graph-connects none
 */
export function opsFollowUpSeed(original) {
    return {
        service: original.service,
        userIds: original.userIds.length > 0 ? [...original.userIds] : null,
        background: original.background,
        wfid: original.wfid,
        csTicketUrl: original.csTicketUrl,
    };
}
/**
 * 補足対応の対リンク 1 本を組み立てる。`follow_up_of` は補足対応側に置いて元依頼を、`follow_up` は元依頼側に
 * 置いて補足対応を指す。起票フローが自動で張るもので、人手の紐付けではないため linkedBy は null（詳細ページで
 * 解除ボタンを出さない）。
 * @graph-connects none
 */
export function buildOpsFollowUpLink(kind, target, linkedAt) {
    return {
        target: 'ops',
        kind,
        ref: target.id,
        url: null,
        title: target.title,
        linkedBy: null,
        linkedAt,
    };
}
//# sourceMappingURL=follow-up.js.map